import { ComponentProps } from 'lib/component-props';
import { Pages } from '.generated/Project.CW.model';
import { getPageUrl } from 'lib/utils/get-base-url';
import StructuredData from 'components/StructuredData';
import { useSitecore } from '@sitecore-content-sdk/nextjs';
import { usePathname } from 'next/navigation';
import { buildTeachingSheetPageJsonLd } from 'lib/schema-builders/teaching-sheets';
import { MinimalSchemaItem } from 'lib/schema-builders/minimal-schema-item';

export type TeachingSheetSchemaProps = ComponentProps & {
  fields: {
    data: {
      item: {
        reviewedBy: {
          targetItems: MinimalSchemaItem[];
        };
        relatedFindCarePages: {
          targetItems: MinimalSchemaItem[];
        };
      };
    };
  };
};

const TeachingSheetSchema = (props: TeachingSheetSchemaProps) => {
  const pagePath = usePathname();
  const { page } = useSitecore();
  const locale = page.locale !== 'en' ? `/${page.locale}` : '';
  const routeFields = page?.layout.sitecore.route;
  const pageUrl = getPageUrl(`${locale}${pagePath}`);
  const data = props.fields?.data?.item;

  const reviewedBy = data?.reviewedBy;
  const relatedFindCarePages = data?.relatedFindCarePages;

  const jsonData = buildTeachingSheetPageJsonLd(
    routeFields as Pages.TeachingPages.TeachingSheets,
    pageUrl,
    relatedFindCarePages?.targetItems?.length ? relatedFindCarePages.targetItems : undefined,
    reviewedBy?.targetItems?.[0]
  );

  return (
    <>
      {page.mode.isEditing && (
        <div className={'p-4 card '}>
          <strong>Schema Component</strong>
          {!props?.fields?.data?.item
            ? ' (Click here, then assign/create data in the right panel)'
            : ' (Configured)'}
        </div>
      )}
      <StructuredData data={jsonData} />
    </>
  );
};

export default TeachingSheetSchema;
